import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerificationSummaryComponent } from './verification-summary.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

/**
 * Created by Arturo Campos on 30/11/18.
 */
@NgModule({
    imports: [CommonModule, NgbTooltipModule],
    declarations: [VerificationSummaryComponent],
})
export class VerificationSummaryModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/verification/verification-summary.module.ts